module.exports = __webpack_public_path__ + "img/clock-outlined.7799a029.svg";